import { Injectable } from '@angular/core';
import {HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

import {environment} from '../../environments/environment';


@Injectable({
  providedIn: 'root'
})
export class PatientsService {

  constructor(private http: HttpClient) { }

  private baseUrl: string = environment.apiUrl;

  private static handleError(error: HttpErrorResponse) {
    console.log(error.error.ResponseMessage);

    // return an observable with a user friendly message
    return throwError('Error! something went wrong.');
  }

  addPatient(patientPayload) {

    // var reqHeaders = new HttpHeaders({'Content-Type':undefined});
    return this.http.post<any>(`${this.baseUrl}/patient/add_patient`, patientPayload)
      .pipe(map(user => {
        return user;
      }));

  }

  updatePatient(data) {
    // var reqHeaders = new HttpHeaders({'Content-Type':undefined});
    return this.http.post<any>(`${this.baseUrl}/patient/editpatient`, data)
      .pipe(map(user => {
        return user;
      }));

  }

  updateEapUser(data) {
    // var reqHeaders = new HttpHeaders({'Content-Type':undefined});
    return this.http.post<any>(`${this.baseUrl}/patient/updateEapUser`, data)
      .pipe(map(user => {
        return user;
      }));

  }

  getUserAppointment(payload): Observable<any> {
    return this.http.post(`${this.baseUrl}/appointments/getpatientappointments`,payload).pipe(
      map((res) => {
        return res;
      }),
      catchError(PatientsService.handleError));
  }

  getAllPatients(key=''): Observable<any> {
    return this.http.get(`${this.baseUrl}/patient/getpatientlist/${key}`).pipe(
      map((res) => {
        return res;
      }),
      catchError(PatientsService.handleError));
  }

  NewPatientListPagination(page,size,payload): Observable<any> {
    return this.http.post(`${this.baseUrl}/patient/NewPatientListPagination?pageNo=${page}&size=${size}`, payload).pipe(
      map((res) => {
        return res;
      }),
      catchError(PatientsService.handleError));
  }

  NewCompanyListPagination(page,size,payload): Observable<any> {
    return this.http.post(`${this.baseUrl}/patient/NewCompanyListPagination?pageNo=${page}&size=${size}`, payload).pipe(
      map((res) => {
        return res;
      }),
      catchError(PatientsService.handleError));
  }

  processNewFreeAppointment(data): Observable<any> {
    return this.http.post(`${this.baseUrl}/appointments/new-free-appointment-booking`,data)
      .pipe(
        map((res) => {
          return res;
        }),
        catchError(PatientsService.handleError));
  }

  getRemainingPackageSessions(payload): Observable<any> {
    return this.http.post(`${this.baseUrl}/appointments/getRemainingPackageSessions`, payload)
      .pipe(
        map((res) => {
          return res;
        }),
        catchError(PatientsService.handleError));
  }

  getUserGiftCodeByEmail(Payload) {
    return this.http.post<any>(`${this.baseUrl}/prices/getUserGiftCodeByEmail`, Payload)
      .pipe(map(res => {
          return res;
        }),
        catchError(PatientsService.handleError));
  }

  sendFeedbackReminderEmail(Payload): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/appointments/sendFeedbackReminderEmail`, Payload)
      .pipe(map(res => {
        return res;
      }));

  }

  getUserSingleDoctorAppointment(payload): Observable<any> {
    return this.http.post(`${this.baseUrl}/appointments/getdoctorappointmentssinglepatient`,payload).pipe(
      map((res) => {
        return res;
      }),
      catchError(PatientsService.handleError));
  }

  getPromoCodeByCodeAndType(Payload) {
    return this.http.post<any>(`${this.baseUrl}/prices/applyPromoCode`, Payload)
      .pipe(map(res => {
          return res;
        }),
        catchError(PatientsService.handleError));
  }

  getPatientById(payload): Observable<any> {
    return this.http.get(`${this.baseUrl}/patient/getpatientbyid/${payload}`).pipe(
      map((res) => {
        return res;
      }),
      catchError(PatientsService.handleError));
  }

  getPatientAppointment(payload): Observable<any> {
    return this.http.post(`${this.baseUrl}/appointments/getpatientadminappointments`, payload)
      .pipe(
        map((res) => {
          return res;
        }),
        catchError(PatientsService.handleError));
  }
  getPatientPlan(payload): Observable<any> {
    return this.http.post(`${this.baseUrl}/plan/getpatientplans`, payload)
      .pipe(
        map((res) => {
          return res;
        }),
        catchError(PatientsService.handleError));
  }
  bookAppointment(Payload): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/appointments/book-appointment`, Payload)
      .pipe(map(res => {
        return res;
      }));

  }

  checkRemainingSession(payload): Observable<any> {
    return this.http.post(`${this.baseUrl}/appointments/checkRemainingSession`, payload)
      .pipe(
        map((res) => {
          return res;
        }),
        catchError(PatientsService.handleError));
  }

  getScheduleById(payload): Observable<any> {
    return this.http.post(`${this.baseUrl}/patient/get-schedule-by-id`, payload)
      .pipe(
        map((res) => {
          return res;
        }),
        catchError(PatientsService.handleError));
  }

}
